export class Hero {
  constructor() {
    this.initVideoHero();
  }

  private initVideoHero(): void {
    const videoHero = document.querySelector('.hero-video');
    if (!videoHero) return;

    const iframe = videoHero.querySelector('iframe');
    if (!iframe) return;

    // Add loading class
    videoHero.classList.add('is-loading');

    // Remove loading class once video is loaded
    iframe.addEventListener('load', () => {
      videoHero.classList.remove('is-loading');
    });
  }
}

// Initialize hero
new Hero();
